import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import ChildInvestorAcademyCommon from '../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import "../../common.css";
import "../../investorAcademy.css";


const IntrinsicValueTimeValues = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    const location = useLocation();
    const history = useHistory();

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>
            
            <div id="main">
                <div id="maintable" className='Common_warrent intrinsic_sec' style={{display: 'table', width: '100%', tableLayout: 'fixed'}}>
                    <div style={{display: 'table-row'}}>
                    <div id="leftbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}} />
                    <div id="maincontainer" style={{display: 'table-cell', width: '100%'}}>
                        <div id="mainnav">
                        <table style={{width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223'}}>
                            <tbody><tr>
                                <td width="20%" style={{textAlign: 'left', visibility: 'hidden'}}>
                                <table className="hasprev hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td width="33px"><div className="prev left" /></td>
                                        <td>
                                        <div className="prevlbl left">
                                            <div className="prevtitle " style={{textAlign: 'left'}}>Previous Topic</div>
                                            <div className="prevname " style={{textAlign: 'left'}}>Understanding the Warrant Structure</div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody></table>
                                </td>
                                <td width="60%" style={{textAlign: 'center'}}>
                                <div id="pagetitlediv" style={{width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto'}}>
                                    <div id="ptitle" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px'}}>Understanding the Warrant Structure</div>
                                    <div id="pname" style={{fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px'}}>Intrinsic Value &amp; Time Value</div>
                                </div>
                                </td>
                                <td width="20%" style={{textAlign: 'right', visibility: 'hidden'}}>
                                <table className="hasnext  hidden-xs" style={{width: '100%', height: '100%', tableLayout: 'fixed'}}>
                                    <tbody><tr>
                                        <td>
                                        <div className="nextlbl right">
                                            <div className="nexttitle " style={{textAlign: 'right'}} />
                                            <div className="nextname " style={{textAlign: 'right'}}>Time Decay</div>
                                        </div>
                                        </td>
                                        <td width="33px"><div className="next right" /></td>
                                    </tr>
                                    </tbody></table>
                                </td>
                            </tr>
                            </tbody></table>
                        </div>
                        <div id="maincontent" style={{marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px'}}>
                        <div id="mainscroll" style={{height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px'}}>
                            <div id="mainscrollcontent">
                            <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
                            {/*<link rel="stylesheet" href="css/common.css"/>*/}
                            <title>Intrinsic Value and Time Value</title>
                            <style dangerouslySetInnerHTML={{__html: "\n            .imgholder img{\n                max-width: 360px; \n/*                max-height: 340px; */\n            }\n            .contentbox p{\n                text-align:left;\n            }\n            .subtitle{\n                height: 46px;\n                line-height: 46px;\n                background:url(\"../../../../../assets/images/education/yellow01.png\") no-repeat left center;\n                color:#FFDA44;\n            }\n            .subtitle span{\n                display:inline;\n                margin: 0px 34px 0px 17px;\n                color:#000000;\n                font-size:1.5em;\n            }\n            .subtitle h3{\n                display:inline;\n            }\n        " }} />
                            <div className="contentbox intrinsic-value">
                                <p>A warrant’s value consists of:</p>
                                <div className="subtitle bg-img"><span>1</span><h3>Intrinsic Value</h3></div>
                                <p>
                                When the exercise price of a call warrant is below the underlying’s current
                                share price, it is said to have ‘intrinsic value’. Have a look at the example below. In this 
                                case the exercise price of MYR 3.00 is at a MYR 0.30 “discount” from the current share price, 
                                this is its intrinsic value. As such, this warrant will have a minimum price of MYR 0.30 – its 
                                intrinsic value. All call warrants with an exercise price lower than the spot price should 
                                always be worth at least the intrinsic value. 
                                </p>
                                <div className="imgholder">
                                <img src='/img/education/intrinsicvalueandtimevalue.png' alt="image" />
                                </div>
                                <div className="subtitle bg-img"><span>2</span><h3>Time value</h3></div>
                                <p>A warrant will usually be worth more than its intrinsic value. As you can see in
                                this example, the warrant is priced at MYR 0.40, which is MYR 0.10 more than its intrinsic 
                                value. This remaining value is called ‘time value’.</p>
                            </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                        </div>
                        </div>
                    </div>
                    <div id="rightbar" className="hidden-xs" style={{display: 'table-cell', width: '80px'}}>
                    </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
                >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                    display: "table",
                    width: "100%",
                    textAlign: "center",
                    color: "#8F8F8F",
                    fontSize: "11px",
                    lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    right: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasnext"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td>
                            <div className="nextlbl right">
                            <div
                                className="nextname "
                                style={{ textAlign: "right", fontSize: "15px" }}
                            >
                                 <Link to="/edu/understanding-warrant-structure/time-decay">
                                    Time Decay
                                 </Link>
                              
                            </div>
                            </div>
                        </td>
                        <td width="33px">
                        <Link to="/edu/understanding-warrant-structure/time-decay">
                            <div className="next right" />
                            </Link>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                <div
                    style={{
                    position: "absolute",
                    width: "46%",
                    height: "35px",
                    left: "10px",
                    bottom: "5px",
                    }}
                >
                    <table
                    className="hasprev"
                    style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                    <tbody>
                        <tr>
                        <td width="33px">
                        <Link to="/edu/understanding-warrant-structure">
                            <div className="prev left" />
                            </Link>
                        </td>
                        <td>
                            <div className="prevlbl left">
                            <div
                                className="prevname "
                                style={{ textAlign: "left", fontSize: "15px" }}
                            > 
                            <Link to="/edu/understanding-warrant-structure">
                                	Understanding the Warrant Structure
                                    </Link>
                            </div>
                            </div>
                        </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs">
                {/* <div className="dbtn dbtn-seminarbtn">
                <Link
                    className="seminarbtn"
                    to="/education/seminar"
                    >
                    <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
      );
}
export default IntrinsicValueTimeValues;